import { forEachMountedShadowRoot } from '#/lib/embed-registry';

import initialWidgetStyles from '../styles.css?inline';

let widgetStyles = initialWidgetStyles;

/**
 * Cached CSSStyleSheet instance. Reused across all shadow roots so the browser
 * only parses the CSS once.
 */
let adoptedSheet: CSSStyleSheet | null = null;

function getOrCreateSheet(): CSSStyleSheet {
  if (!adoptedSheet) {
    adoptedSheet = new CSSStyleSheet();
    adoptedSheet.replaceSync(widgetStyles);
  }
  return adoptedSheet;
}

/**
 * Applies widget styles to a shadow root using the adoptedStyleSheets API.
 * Unlike a <style> element, adopted stylesheets cannot be removed by
 * third-party scripts (e.g., CobrowseIO) that manipulate the DOM via
 * MutationObservers or innerHTML.
 */
function syncWidgetStyles(root: ShadowRoot) {
  const sheet = getOrCreateSheet();
  if (!root.adoptedStyleSheets.includes(sheet)) {
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
  }
}

export function ensureWidgetStyles(root: ShadowRoot) {
  syncWidgetStyles(root);
}

function refreshShadowRoots() {
  // Update the shared sheet content
  if (adoptedSheet) {
    adoptedSheet.replaceSync(widgetStyles);
  }

  forEachMountedShadowRoot((root) => {
    syncWidgetStyles(root);
  });
}

if (import.meta.hot) {
  import.meta.hot.accept('../styles.css?inline', (nextModule) => {
    if (nextModule && 'default' in nextModule) {
      widgetStyles = nextModule.default;
      refreshShadowRoots();
    }
  });
}
